import { BCMSCurrency, BCMSRecord, Branding, Link, useGlobalController, useModel, useRoute } from "@bcm-dev/bcms-vite";
import { Account, AddBiller, Autopay, Bill, Biller, BillerGroup, Payment, Profile, ShowOnDesktop, ShowOnMobile } from "model/";
import { useState } from "react";

import BillerGroupsAccordion from "compid/custom-ui/CustomAccordion/components/BillerGroupsAccordion";
import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import LeftColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/LeftColumnContainer";
import RightColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/RightColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import WidgetContainer from "compid/shared/containers/WidgetContainer";
import WidgetHeaderView from "compid/shared/containers/WidgetContainer/views/WidgetHeaderView";
import AlphaBillerView from "compid/shared/views/BillerView/components/views/AlphaBillerView";
import NewPaymentBillerView from "compid/shared/views/BillerView/components/views/NewPaymentBillerView";
import PaidUpcomingBillerView from "compid/shared/views/BillerView/components/views/PaidUpcomingBillerView";
import RecentActivityView from "compid/shared/views/BillerView/components/views/RecentActivityView";
import UpcomingBillerView from "compid/shared/views/BillerView/components/views/UpcomingBillerView";
import NavView from "compid/shared/views/NavView";
import TableView, { TableRowView } from "compid/shared/views/TableView";
import NewAutopayUpsellView from "compid/shared/views/UpsellView/components/views/NewAutopayUpsellView";
import TrialeBillUpsellView from "compid/shared/views/UpsellView/components/views/TrialeBillUpsellView";
import UpselleBillView from "compid/shared/views/UpsellView/components/views/UpselleBillView";
import VerticalMenuView from "compid/shared/views/VerticalMenuView";
import FindBillsWidget from "compid/shared/widgets/FindBillsWidget";
import MultipayNotice from "compid/shared/widgets/MultipayNotice";
import UIButton from "compid/ui/UIButton";
import UIDropdownButton, { UIDropdownContentItem } from "compid/ui/UIDropdownButton";
import UIToggle from "compid/ui/UIToggle";
import { MultiPayContextWrapper } from "compid/workflows/MultiPay";
import { SVGAsset } from "res";
import BillersAddedSuccessPrompt from "./components/BillersAddedSuccessPrompt";
import NoMyBillersMessage from "./components/NoMyBillersMessage";
import SearchForBillerField from "./components/SearchForBillerField";
import "./styles.css";

export default function PayBillsPage(props) {


  return (
    <PageView className="pay-bills-page">
      <ShowOnDesktop>
        <div className="show-on-desktop">
          <Branding id="menu_position_rxp22" value="Vertical">
            <div className="flex-container flex-horizontal vertical-menu-page-container">
              <PayBillsContent showVertical={true}>
                <VerticalMenuView />
              </PayBillsContent>
            </div>
          </Branding>
          <Branding id="menu_position_rxp22" exp={value => value === "Horizontal" || value === "undefined"}>
            <PayBillsContent>
              <NavView />
            </PayBillsContent>
          </Branding>
        </div>
      </ShowOnDesktop>
      <ShowOnMobile>
        <div className="show-on-mobile show-on-tablet">

          <PayBillsContent>
            <NavView />
          </PayBillsContent>
        </div>
      </ShowOnMobile>
    </PageView>
  );

}
function PayBillsContent(props) {
  const billerGroupName = props.billerGroupName ?? "[biller group name]";
  
  const controller = useGlobalController();
  const navigate = useRoute();
  const model = useModel();
  const [searchState, setSearchState] = useState({ "value": "", "dropdown": false });

  const addBiller = evt => {
    navigate("/AddBillerWorkflow", { "state": { "name": searchState.value } })
      ;
  }
  // Initalize the global Controllers for the required model classes
  BCMSRecord.globalControllerFor([Account, Payment, Biller, Bill, Autopay, AddBiller, Profile, BillerGroup], controller);

  const accounts = Account.initAll().map(account => <TableRowView labelClass="gray-text" dataClass="text-right gray-text" key={"account_" + account.id} label={account.name + " " + account.number} data={account.balance.format()} />, []);
  const billers = Biller.initAll();

  const { branding } = model ?? {};
  const { options } = branding ?? {};

  const [alphaSort, setAlphaSort] = useState(options.pay_bills_sort_rxp22 === "Alphabetically" ? true : false);

  const profile = Profile.init(model.profile);

  const shouldShowNoBillers = billers.filter(item => item.addType !== "verification_add" && item.addType !== "quick_add", []).length === 0;
  const addedBillers = billers.filter(item => item.addType === "verification_add" || item.addType === "quick_add", []);

  // START: set the total amount for bills.
  let totalAmountDue = 0;

  for (var i = 0; i < model.bills.length; i++) {
    const bill = model.bills[i];
    const billStatus = bill.billStatus.toLowerCase();
    if (billStatus === 'due') {
      totalAmountDue += parseFloat(bill.billAmount);
    }
  }

  const totalAmountDueCurrency = BCMSCurrency.toCurrency(totalAmountDue);
  const groups = BillerGroup.initAll()
  // END: set the total amount for bills.

  // getUpSale :: Bill -> React.Component | STRING
  // Return either a component or an emptry string based on eBill status and if the biller is a paper biller
  // NOTE: Defining function here instead of re-defining 3 times in components that use it
  const getUpSale = bill => {
    if (bill.biller.paymentType === "electronic" || bill.biller.paymentType === "instantPayment" || bill.biller.paymentType === "withinMinutes") {
      switch (bill.biller.eBillStatus) {
        case "Not Enrolled":
          return <UpselleBillView onClick={() => navigate(`/requestEBillWorkflow/${bill.biller.id}`)}
            biller={bill.biller} dataPoint={`My_Billers_Biller`} />

        case "Trial":
          return <TrialeBillUpsellView daysRemaining={bill.biller.eBillTrialPeriod} />

        case "Active":
          return !(bill.biller.autopay instanceof Autopay) ? <NewAutopayUpsellView dataPoint={ `New_Autopay_Upsell`} biller={ bill.biller } onClick={() => navigate(`/addAutoPayWorkflow/${bill.biller.id}`)} /> : "";

        default:
          return "";
      }
    } else if (bill.biller.paymentType === "virtualCard") {
      return !(bill.biller.autopay instanceof Autopay) ? <NewAutopayUpsellView dataPoint={ `New_Autopay_Upsell`} biller={ bill.biller } onClick={() => navigate(`/addAutoPayWorkflow/${bill.biller.id}`)} /> : "";
    } else {
      return "";
    }
  };
  const toggleGroups = () => {
    profile.hasBillerGroupsOn = !profile.hasBillerGroupsOn

    BCMSRecord.batch([
      Profile.update(profile)
    ], controller);

  }
  return <>
    {props.children}
    <PageLayoutContainer>
      <MultiPayContextWrapper>
        <LeftColumnContainer>
          {/*<StickyHeaderView>*/}
            <BillersAddedSuccessPrompt />
          {/*</StickyHeaderView>*/}

          {/*<StickyHeaderView>*/}
          <div>
            <div className="flex-container flex-horizontal align-center search-input-container">

              <div className="flex-width input-container">
                <SearchForBillerField searchState={searchState} setSearchState={setSearchState}
                  placeholder={<><span className="tablet-desktop-search-label">Search existing biller</span><span className="show-on-mobile">Search existing biller</span></>}
                  dataPoint="Pay_Bills_Search_For_Biller" />
              </div>

              <ButtonContainer className="add-biller-button" dataPoint="Search_For_Biller_Add_Biller">

                <UIButton className="secondary-button" dataPoint="Pay_Bills_Add_Biller" onClick={addBiller}>Add biller</UIButton>

              </ButtonContainer>
            </div>
          </div>

          <ShowOnDesktop>
            <MultipayNotice />
          </ShowOnDesktop>

          {/*</StickyHeaderView>*/}
          <WidgetContainer>
            {/*<StickyWidgetHeaderView>*/}
              <WidgetHeaderView title={
                <div className="flex-container flex-horizontal align-center">
                  <span data-point="Upcoming_Bills_Header_Text">Unpaid bills</span>
                  
                  <span className="tooltip">
                    <SVGAsset id="InfoIcon" className="right-icon header-icon" />

                    <span className="tooltip-text">
                      Displays any unpaid bills and their due dates.
                    </span>
                  </span>
                </div>} dataPoint="Upcoming_Bills_Header">
                {totalAmountDue !== 0 && <p className="gray-text sub-text">Total Due: {totalAmountDueCurrency}</p>}
              </WidgetHeaderView>
            {/*</StickyWidgetHeaderView>*/}

            <UpcomingBillerView />
          </WidgetContainer>

          <WidgetContainer className="my-billers">
            {/*<StickyWidgetHeaderView>*/}
              <WidgetHeaderView
                title={
                  <div className="flex-container flex-horizontal align-center" key="group-toggle">
                    <span className="set-width my-billers-header" data-point="Pay_Bills_My_biller_header">My billers</span>
                    <UIToggle className="set-width" text="Groups" checked={profile.hasBillerGroupsOn} onChange={toggleGroups} dataPoint="Pay_Bills_Group_Toggle" />

                    {profile.hasBillerGroupsOn &&
                      <span key="group-link">
                        <Link to="/billerGroupsWorkflow" className="create-link">
                          <span className="group-link-text" data-point="Pay_Bills_Group_Link">
                            {groups.length > 0 ? "Manage" : "Create"}
                          </span>
                        </Link>
                      </span>}
                  </div>
                }>


                {/* To wrap the Sort by text add a class of .toggle-on to the .sort-dropdown div */}
                <UIDropdownButton text="Sort by" cheveron={<div className="sort-by-triangle set-width"></div>} onChange={setAlphaSort} value={alphaSort}>
                  <UIDropdownContentItem text={"Name"} value={true} />
                  <UIDropdownContentItem text={"Payment Date"} value={false} />
                </UIDropdownButton>


              </WidgetHeaderView>
            {/*</StickyWidgetHeaderView>*/}

            <Branding id="bill_discovery_rxp22" value="true">
              {addedBillers.length > 0 && <FindBillsWidget />}
            </Branding>

            {/*<FindBillsPromoView />*/}
            {!shouldShowNoBillers &&
              <>
                {!profile.hasBillerGroupsOn && <>
                  {alphaSort && <AlphaBillerView getUpSale={getUpSale} group={undefined} />}
                  {
                    !alphaSort &&
                    <>  <PaidUpcomingBillerView getUpSale={getUpSale} group={undefined} />
                      <NewPaymentBillerView getUpSale={getUpSale} group={undefined} />
                    </>
                  }
                </>}
                {profile.hasBillerGroupsOn && <BillerGroups getUpSale={getUpSale} alphaSort={alphaSort} />
                }
              </>
            }

            {shouldShowNoBillers && <NoMyBillersMessage />}

          </WidgetContainer>
        </LeftColumnContainer>

        <RightColumnContainer>
          <Branding id="account_balances_rxp22" value="true">
            <WidgetContainer>
              <WidgetHeaderView title="Account Balances" dataPoint="Account_Balances_Header" />

              <TableView>
                {accounts}
              </TableView>
            </WidgetContainer>
          </Branding>
          <WidgetContainer>
            <WidgetHeaderView title={
              <div className="flex-container flex-horizontal align-center">
                Recent Activity
                
                <span className="tooltip">
                  <SVGAsset id="InfoIcon" className="right-icon header-icon show-on-desktop" />

                  <span className="tooltip-text">
                    Displays all payments scheduled within 30 days before and after the current date. Section totals are listed at the top. Select a payment to view, edit, or cancel it.
                  </span>
                </span>
              </div>
            } dataPoint="Recent_Activity_Header">
              <Link className="blue-text link" to="/activity" dataPoint="Recent_Activity_View_All_Activity_Link">View all activity</Link>
            </WidgetHeaderView>
            <RecentActivityView />
          </WidgetContainer>
        </RightColumnContainer>
      </MultiPayContextWrapper>
    </PageLayoutContainer>
  </>
}
function BillerGroups(props) {
  const groups = BillerGroup.initAll().filter(group => group.show);
  const billersByGroup = BillerGroup.billerByGroup(Biller.initAll());
  const billerGroups = groups.reduce((groups, group) => {
    if (billersByGroup[group.id]) {
      groups.push(<BillerGroupView name={group.name} group={group.id} getUpSale={props.getUpSale} key={group.name + group.id} alphaSort={props.alphaSort} />)
    }

    return groups;
  }, [])
  const defaultBillerGroups =
    <>

      {billersByGroup.default && <BillerGroupView name={"Other billers"} group={"default"} getUpSale={props.getUpSale} key={"default"} alphaSort={props.alphaSort} />}

    </>

  return [billerGroups, defaultBillerGroups];
}

function BillerGroupView(props) {
  const { name, group } = props;
  return <>
    {props.alphaSort && <BillerGroupsAccordion text={name} key={"accordion" + group.id} dataPoint={`Group_Accordion_${group}`}>
      <AlphaBillerView getUpSale={props.getUpSale} group={group} />
    </BillerGroupsAccordion>
    }

    {!props.alphaSort &&
      <>   <BillerGroupsAccordion text={name} key={"accordion" + group.id} dataPoint={`Group_Accordion_${group}`}>
        <PaidUpcomingBillerView getUpSale={props.getUpSale} group={group} key={"upcoming" + group.id} />
        <NewPaymentBillerView getUpSale={props.getUpSale} group={group} key={"new" + group.id} />
      </BillerGroupsAccordion>
      </>
    }
  </>




}